import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "revoked-text"
}
const _hoisted_2 = {
  key: 1,
  class: "max-double-line"
}

import { computed, ref, onMounted } from '../../../../../adapter-vue';
import {
  TUIStore,
  StoreName,
  IMessageModel,
  TUITranslateService,
} from '@tencentcloud/chat-uikit-engine';
import {
  getBoundingClientRect,
  getScrollInfo,
} from '@tencentcloud/universal-api';
import { isUniFrameWork } from '../../../../../utils/env';
import {
  Toast,
  TOAST_TYPE,
} from '../../../../../components/common/Toast/index';
import type { ICloudCustomData, IQuoteContent } from './interface.ts';
import { transformTextWithKeysToEmojiNames } from '../../../emoji-config';

export interface IProps {
  message: IMessageModel;
}

export interface IEmits {
  (e: 'scrollTo', scrollHeight: number): void;
  (e: 'blinkMessage', messageID: string | undefined): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    message: { default: () => ({} as IMessageModel) }
  },
  emits: ["scrollTo", "blinkMessage"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;

let selfAddValue = 0;
const hasQuoteContent = ref(false);
const messageQuoteContent = ref<IQuoteContent>({} as IQuoteContent);

const isMessageRevoked = computed<boolean>(() => {
  try {
    const cloudCustomData: ICloudCustomData = JSON.parse(
      props.message?.cloudCustomData || '{}'
    );
    const quotedMessageModel = TUIStore.getMessageModel(
      cloudCustomData.messageReply.messageID
    );
    return quotedMessageModel?.isRevoked;
  } catch (error) {
    return true;
  }
});

onMounted(() => {
  try {
    const cloudCustomData: ICloudCustomData = JSON.parse(
      props.message?.cloudCustomData || '{}'
    );
    hasQuoteContent.value = Boolean(cloudCustomData.messageReply);
    if (hasQuoteContent.value) {
      messageQuoteContent.value = cloudCustomData.messageReply;
    }
  } catch (error) {
    hasQuoteContent.value = false;
  }
});

async function scrollToOriginalMessage() {
  // if (isMessageRevoked.value) {
  //   return;
  // }
  const originMessageID = messageQuoteContent.value?.messageID;
  const currentMessageList = TUIStore.getData(StoreName.CHAT, 'messageList');
  const isOriginalMessageInScreen = currentMessageList.some(
    (msg) => msg.ID === originMessageID
  );
  if (originMessageID && isOriginalMessageInScreen) {
    try {
      const scrollViewRect = await getBoundingClientRect(
        '#messageScrollList',
        'messageList'
      );
      const originalMessageRect = await getBoundingClientRect(
        '#tui-' + originMessageID,
        'messageList'
      );
      const { scrollTop } = await getScrollInfo(
        '#messageScrollList',
        'messageList'
      );
      const finalScrollTop =
        originalMessageRect.top +
        scrollTop -
        scrollViewRect.top -
        (selfAddValue++ % 2);
      const isNeedScroll = originalMessageRect.top < scrollViewRect.top;
      if (!isUniFrameWork && window) {
        const scrollView = document.getElementById('messageScrollList');
        if (isNeedScroll && scrollView) {
          scrollView.scrollTop = finalScrollTop;
        }
      } else if (isUniFrameWork && isNeedScroll) {
        emits('scrollTo', finalScrollTop);
      }
      emits('blinkMessage', originMessageID);
    } catch (error) {
      console.error(error);
    }
  } else {
    Toast({
      message: TUITranslateService.t('TUIChat.无法定位到原消息'),
      type: TOAST_TYPE.WARNING,
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_unref(hasQuoteContent))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({
      'reference-content': true,
      reverse: __props.message.flow === 'out',
    }),
        onClick: scrollToOriginalMessage
      }, [
        (_unref(isMessageRevoked))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(TUITranslateService).t('TUIChat.引用内容已撤回')), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(messageQuoteContent).messageSender) + ": " + _toDisplayString(_unref(transformTextWithKeysToEmojiNames)(
          _unref(messageQuoteContent).messageAbstract
        ) || _unref(TUITranslateService).t('TUIChat.聊天记录')), 1))
      ], 2))
    : _createCommentVNode("", true)
}
}

})